import React from 'react';
import { Box, Typography, Divider, Paper } from '@material-ui/core';
import CurrencySymbol from './CurrencySymbol';

export default function BillSummary(props) {
  let t = props.t;

  return (
    <Box mt={3} mb={3} display="flex" justifyContent="center">
      <Paper 
        elevation={3} 
        style={{ 
          width: '100%', 
          maxWidth: '450px', 
          borderRadius: '16px', 
          padding: '24px', 
          backgroundColor: '#ffffff' 
        }}
      >
        <Typography 
          variant="h5" 
          style={{ 
            fontWeight: 'bold', 
            marginBottom: '20px', 
            textAlign: 'center', 
            color: '#333' 
          }}
        >
          {t({ id: "bill_summary" })}
        </Typography>
        
        <Divider style={{ marginBottom: '20px' }} />

        <Box display="flex" justifyContent="space-between" mb={1.5}>
          <Typography variant="body1" style={{ color: '#555', fontSize: '1.1rem' }}>
            {t({ id: "subtotal" })}
          </Typography>
          <Typography variant="body1" style={{ fontWeight: '500', color: '#333', fontSize: '1.1rem' }}>
            <CurrencySymbol /> {Math.max(0, props.totalPrice - (props.taxPrice + (props.container_price || 0))).toFixed(2)}
          </Typography>
        </Box>

        <Box display="flex" justifyContent="space-between" mb={1.5}>
          <Typography variant="body1" style={{ color: '#555', fontSize: '1.1rem' }}>
            {t({ id: "tax" })}
          </Typography>
          <Typography variant="body1" style={{ fontWeight: '500', color: '#333', fontSize: '1.1rem' }}>
            <CurrencySymbol /> {props.taxPrice.toFixed(2)}
          </Typography>
        </Box>

        {props.orderType && props.orderType.toLowerCase() === "take away" && props.container_price > 0 && (
          <Box display="flex" justifyContent="space-between" mb={1.5}>
            <Typography variant="body1" style={{ color: '#555', fontSize: '1.1rem' }}>
              {t({ id: "container_charge" })}
            </Typography>
            <Typography variant="body1" style={{ fontWeight: '500', color: '#333', fontSize: '1.1rem' }}>
              <CurrencySymbol /> {props.container_price.toFixed(2)}
            </Typography>
          </Box>
        )}

        <Divider style={{ margin: '20px 0' }} />

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="h6" style={{ fontWeight: 'bold', color: '#333', fontSize: '1.3rem' }}>
            {t({ id: "total_amt" })}
          </Typography>
          <Typography variant="h5" style={{ fontWeight: 'bold', color: '#000', fontSize: '1.5rem' }}>
            <CurrencySymbol /> {props.totalPrice.toFixed(2)}
          </Typography>
        </Box>

        <Typography 
          variant="caption" 
          style={{ 
            color: '#888', 
            display: 'block', 
            textAlign: 'center', 
            marginTop: '20px', 
            fontStyle: 'italic' 
          }}
        >
          Note: Take away/parcel order may include container charge if required.
        </Typography>
      </Paper>
    </Box>
  );
}
